import NanduScores from './NanduScores';

export default NanduScores;
